module.exports = __webpack_public_path__ + "img/RecycledItem.23d2f139.jpg";